import { normalizeSegmentationConfig } from './segmentationModel';

export function getSegmentationConfigPublishWarnings(annotationUI) {
    const config = normalizeSegmentationConfig(annotationUI?.config);
    const warnings = [];
    if (!Array.isArray(config.categories) || config.categories.length === 0) {
        warnings.push('Add at least one segmentation category in Annotation UI configuration.');
    }
    const missingNames = (config.categories || []).filter((c) => !String(c.label || c.id).trim());
    if (missingNames.length > 0) {
        warnings.push('Every segmentation category should have a display label.');
    }
    return warnings;
}

